/**
 * @generated SignedSource<<8015f0d13c94d9327bfbef66b468b580>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksArticleAcknowledgementGateOverlayArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "hooksArticleAcknowledgementGateOverlayArticle";
};
export type hooksArticleAcknowledgementGateOverlayArticle$key = {
  readonly " $data"?: hooksArticleAcknowledgementGateOverlayArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksArticleAcknowledgementGateOverlayArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksArticleAcknowledgementGateOverlayArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "ea1179bf57f7348c2e2ebb1700857a73";

export default node;
